<template>
  <div class="notice-block f-column-b mt-20" :style="computedHeightStyle">
    <block-head :title="title" :icon="icon" :more-btn-url="moreBtnUrl">
      <ul v-if="!hidTab" class="f-start-c flex-1">
        <li v-for="nt in systemTypeList" :key="nt[code]" class="fc99 mr-17" style="margin-top:15px" :class="{active: nt[code] === activeType}" @click="changesystemType(nt[code])">{{ nt[label] }}</li>
      </ul>
    </block-head>
    <div class="list">
      <el-table
        v-if="list.length"
        class="project-table"
        height="100%"
        :data="list"
        fit
        :default-sort="{prop: 'endTime', order: null}"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        @sort-change="handleSortChange"
        @row-click="rowClick"
      >
        <el-table-column label="项目名称" min-width="180" header-align="center">
          <template slot-scope="{row}">
            <div class="text-cut" :title="row.title">
              {{ row.title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="fbstartDate" label="发布时间" width="350" align="center" />
      </el-table>
      <no-data v-else :no-txt="noTxt" :no-img="noImg" :text="$attrs.text" />
    </div>
  </div>
</template>

<script>
import {
  getConstantDic,
  INFO_TYPE_OPTIONS2,
  PROJECT_STATUS_OPTIONS,
  SELECT_OPTION_CONFIG,
  NAV_MENU_CODE
} from "@/utils/constant";
import noticeApi from "@/api/notice";
import NoData from "@/components/NoData.vue";
import BlockHead from "@/views/home/components/BlockHead.vue";
import { parseTime } from "@/filters";

export default {
  name: "NoticechangeBlock",
  components: { BlockHead, NoData },
  props: {
    defaultParams: {
      type: Object,
      default: () => ({})
    },
    icon: {
      type: String,
      default: "notice"
    },
    title: {
      type: String,
      default: ""
    },
    hidTab: {
      type: Boolean,
      default: false
    },
    // 需要隐藏的 column
    hidColumns: {
      type: Array,
      default: () => []
    },
    // 模块高度
    blockHeight: {
      type: [Number, String],
      default: "458px"
    },
    // 最多显示多少行
    rows: {
      type: [Number, String],
      default: 8
    },
    noTxt: {
      type: Boolean,
      default: true
    },
    noImg: {
      type: Boolean,
      default: false
    },
    noticeType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      systemTypeList: getConstantDic(INFO_TYPE_OPTIONS2),
      // 项目状态  未开始：0 报名中：1 报名截止：2 公示中：3 公示结束 ：4 已中标：5 已废标：6）
      statusList: Object.values(PROJECT_STATUS_OPTIONS),
      systemType: "CQJY",
      code: SELECT_OPTION_CONFIG.CODE,
      label: SELECT_OPTION_CONFIG.LABEL,
      list: []
    };
  },
  // 监听属性 类似于data概念
  computed: {
    moreBtnUrl() {
      if (this.noticeType == "CJGG") {
        if (this.systemType == "ZBCG") {
          return "/notice/list/" + NAV_MENU_CODE.CJGGZBCG
        } else {
          return "/notice/list/" + NAV_MENU_CODE.CJGGCQJY
        }
      } else if (this.noticeType == "BGGG") {
        if (this.systemType == "ZBCG") {
          return "/notice/list/" + NAV_MENU_CODE.BGGGZBCG
        } else {
          return "/notice/list/" + NAV_MENU_CODE.BGGGCQJY
        }
      }
    },
    activeType() {
      return this.systemType || ""
    },
    computedHeightStyle() {
      let height = this.blockHeight
      if (typeof this.blockHeight === "string") { height = height.replace("px", "") }
      return { height: height + "px" }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList()
  },
  // 方法集合
  methods: {
    changesystemType(code) {
      this.systemType = code
      this.getList()
    },
    // 获取列表
    getList() {
      const params = {
        pageNo: 1,
        pageSize: this.rows,
        systemType: this.systemType,
        noticeType: this.noticeType,
        ...this.defaultParams
      }
      noticeApi.page(params).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          this.total = data.total || 0
          list.forEach(e => {
            e.fbstartDate = parseTime(e.fbstartDate, "{y}-{m}-{d}")
          })
          this.list = data.list || []
        }
      })
    },
    headerCellStyle({ columnIndex }) {
      return "background-color: #f9f9f9;padding: 4px 0;"
    },
    cellStyle({ columnIndex, rowIndex }) {
      let str = "padding: 9px 0;cursor:pointer;"
      if (columnIndex === 4) {
        str += "display: flex;justify-content: center;"
      }
      if (rowIndex === 7) {
        str += "border: none;"
      }
      return str
    },
    // 行点击
    rowClick(row) {
      let url = ""
      if (this.noticeType == "CJGG") {
        if (this.systemType == "ZBCG") {
          url = NAV_MENU_CODE.CJGGZBCG
        } else {
          url = NAV_MENU_CODE.CJGGCQJY
        }
      } else if (this.noticeType == "BGGG") {
        if (this.systemType == "ZBCG") {
          url = NAV_MENU_CODE.BGGGZBCG
        } else {
          url = NAV_MENU_CODE.BGGGCQJY
        }
      }
      const route = this.$router.resolve({
        path: "/notice/detail/" + url,
        query: {
          id: row.id,
          systemType: this.systemType || this.defaultParams.systemType
        }
      })
      window.open(route.href)
    },
    // 排序
    handleSortChange({ order }) {
      this.getList("0")
    }
  }
};
</script>

<style scoped lang="scss">
.notice-block{
  width: 100%;

	.list{
		flex: 1;
		min-height: 0;
		border: 1px solid #ddd;
		margin-top: 18px;
		.project-table {
			&::before{
				height: 0;
			}
			.table-btn {
				display: inline-block;
				width: 70px;
				height: 24px;
				color: #fff;
				text-align: center;
			}
		}
	}
}
</style>
